import { useMutation } from "react-query";
import downloadActiveNotesCSV from "../services/downloadActiveNotesCSV";

function useDownloadActiveNotesCSV() {
  return useMutation(["download-active-notes-csv"], downloadActiveNotesCSV);
}

export default useDownloadActiveNotesCSV;
